import React from "react";
import { CardPageItem } from "../../../custom/Page";
import DarkBar from "../DarkBar";
import { Box, CardContent, Collapse, List, ListItem, ListItemText } from "@material-ui/core";
import { FormattedMessage } from "react-intl";
import Number from "../../../custom/Number";
import IconArrowUp from "@material-ui/icons/KeyboardArrowUp";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  listItem: {
    userSelect: "text",
  },
  detailItem: {
    paddingLeft: theme.spacing(2),
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    marginLeft: theme.spacing(1),
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  iconOpen: {
    transform: "rotate(180deg)",
  },
  primaryBox: {
    display: "flex",
    alignItems: "center",
  },
}));

const SummaryCommissionSectionManager = ({ currentUser, manager, managerSplit, leadership, totalCurrentMonth, totalPreviousMonth }) => {
  const [open, setOpen] = React.useState(!currentUser.hideValues);
  const classes = useStyles();

  const hasManagerSplitOrLeadershipOrManager = managerSplit > 0 || leadership > 0 || manager > 0;

  const handleOpen = () => {
    if (hasManagerSplitOrLeadershipOrManager) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <CardPageItem
      raised
      margin={1}
    >
      <DarkBar text="app.comission.lct" />
      <CardContent>
        <List>
          <ListItem
            button={hasManagerSplitOrLeadershipOrManager}
            onClick={handleOpen}
            className={classes.listItem}
          >
            <ListItemText
              primary={
                <Box className={classes.primaryBox}>
                  <FormattedMessage id="app.month.current" />
                  {hasManagerSplitOrLeadershipOrManager && (
                    <Box className={`${classes.iconBox} ${open ? classes.iconOpen : ""}`}>
                      <IconArrowUp />
                    </Box>
                  )}
                </Box>
              }
            />
            <Number
              value={totalCurrentMonth}
              hideValue={currentUser.hideValues}
              currency="LCT"
            />
          </ListItem>

          {hasManagerSplitOrLeadershipOrManager && (
            <Collapse
              in={open}
              timeout="auto"
              unmountOnExit
            >
              {manager > 0 && (
                <ListItem className={classes.detailItem}>
                  <ListItemText
                    className={classes.detailItem}
                    primary={<FormattedMessage id="app.commission.type.BONUS_MANAGER" />}
                  />
                  <Number
                    value={manager}
                    hideValue={currentUser.hideValues}
                    currency="LCT"
                  />
                </ListItem>
              )}
              {leadership > 0 && (
                <ListItem className={classes.detailItem}>
                  <ListItemText
                    className={classes.detailItem}
                    primary={<FormattedMessage id="app.commission.type.BONUS_LEADERSHIP_ONE_TIME" />}
                  />
                  <Number
                    value={leadership}
                    hideValue={currentUser.hideValues}
                    currency="LCT"
                  />
                </ListItem>
              )}
              {managerSplit > 0 && (
                <ListItem className={classes.detailItem}>
                  <ListItemText
                    className={classes.detailItem}
                    primary={<FormattedMessage id="app.commission.type.BONUS_MANAGER_SPLIT" />}
                  />
                  <Number
                    value={managerSplit}
                    hideValue={currentUser.hideValues}
                    currency="LCT"
                  />
                </ListItem>
              )}
            </Collapse>
          )}

          <ListItem className={classes.listItem}>
            <ListItemText primary={<FormattedMessage id="app.month.previous" />} />
            <Number
              value={totalPreviousMonth}
              hideValue={currentUser.hideValues}
              currency="LCT"
            />
          </ListItem>
        </List>
      </CardContent>
    </CardPageItem>
  );
};

export default SummaryCommissionSectionManager;
